export const navigation = {
  montessori: "Montessori",
  openHouse: "Jornada Puertas Abiertas",
  contact: "Contacto",
  aboutUs: "Sobre Nosotros",
  prices: "Precios",
  school: {
    main: "El Colegio",
    aboutUs: "Quiénes Somos",
    montessori: "Método Montessori",
    trilingual: "Educación Trilingüe"
  },
  schoolLife: {
    main: "Vida Escolar",
    calendar: "Calendario Escolar",
    extracurriculars: "Extraescolares",
    services: "Servicios"
  },
  admissions: {
    main: "Admisiones",
    process: "Proceso de Admisión",
    prices: "Precios y Tarifas",
    visit: "Visita el Colegio",
    openHouse: "Jornada de Puertas Abiertas"
  },
  activities: {
    main: "Actividades",
    birthdays: "Cumpleaños",
    easterCamp: "Campamento Semana Santa",
    summerCamp: "Campamento Verano",
    christmasCamp: "Campamento Navidad",
    courses: "Cursos"
  },
  extracurriculars: "Extraescolares",
  courses: "Cursos",
  camps: {
    main: "Campamentos",
    easter: "Semana Santa",
    summer: "Verano"
  }
};
